import React from 'react';
import { GroupGuardrailComplianceCard } from '@internal/backstage-backstage-plugin-guardrail-compliance';
import { DhDockHomepage } from '@internal/backstage-plugin-dh-dock-homepage';
import { Entity } from '@backstage/catalog-model';
import { featureFlagsObj } from '../../hooks/config';
import useFeatureFlags from '../../hooks/useFeatureFlags';
import { HomePage } from './HomePage';
import { productCatalogBaseUrl } from '../../utils';

const getHomepageEditUrl = (entity: Entity, entities: Entity[] = []) => {
  if (entity.kind.toLowerCase() === 'system') {
    return `${productCatalogBaseUrl}${encodeURIComponent(entity.metadata.name)}`;
  }
  if (entity.kind.toLowerCase() === 'group') {
    const objectId = entity.metadata.annotations?.['graph.microsoft.com/group-id'];
    const groupInfo = objectId ? entities.find(item =>
      item.kind.toLowerCase() === 'groupinfo' &&
      typeof item.spec?.entraGroupObjectId === 'string' &&
      item.spec.entraGroupObjectId.toLowerCase() === objectId.toLowerCase(),
    ) : undefined;
    const logicalName = groupInfo?.spec?.entityLogicalName;
    if (groupInfo && typeof logicalName === 'string' && logicalName.trim()) {
      const url = new URL(productCatalogBaseUrl);
      url.searchParams.set('etn', logicalName);
      url.searchParams.set('id', groupInfo.metadata.name);
      return url.toString();
    }
  }
  return undefined;
};

export const FlaggedHomePage = () => {
  const { isOn } = useFeatureFlags({
    id: featureFlagsObj['dh-dock-homepage'],
  });

  return isOn ? (
    <HomePage>
      <DhDockHomepage
        getEditUrl={getHomepageEditUrl}
        guardrails={<GroupGuardrailComplianceCard variant="homepage" />}
      />
    </HomePage>
  ) : (
    <HomePage />
  );
};